import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from '@dbk/ui-modal';
import { Large } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import moment from 'moment';
import { ErrorIcon, SuccessIcon } from '../../components/common/icons';
import styles from './payment-confirmation.styles';
import { FormattedMessage } from '@dbk-legacy/format';

export default ({ status, messages, onDone, onNewPayment,execDate }) => (
  <Modal
    isActive
    size="large"
    hideCloseButton
    title={status==='success' ? 
      messages['app.payment.pageTitle.confirm.payment'] : 
      messages['app.payment.pageTitle.payment.status']}
    disableOutsideClick
    onClose={() => {}}
    header={
      status==='success' ? 
      messages['app.payment.pageTitle.confirm.payment'] : 
      messages['app.payment.pageTitle.payment.status']}
    content={
      <div className="modal-payment-status">
        {status==='success' ?
        <div className="modal-content">
          <div className="payment-status-message">
            <SuccessIcon width={30} height={30} />
            <Large secondary tabIndex={0}>
              {messages['app.payments.confirmation.success']}
            </Large>
          </div>
          <div>
            <FormattedMessage
              tabIndex={0}
              id={'app.payments.confirmation.successMessage'}
              values={{ executionDate: moment(execDate).format('DD/MMM/YYYY') }} />
          </div>
        </div> :
          status==='reject' ?
        <div className="modal-content">
          <div className="payment-status-message">
            <SuccessIcon width={30} height={30} />
            <Large secondary role="alert" tabIndex={0}>
              {messages['app.payments.confirmation.success']}
            </Large>
          </div>
          <div>
            <Large secondary role="alert" tabIndex={0}>{messages['app.payments.cancellation.errorMessage']}</Large>
          </div>
        </div>:
        <div className="modal-content">
          <div className="payment-status-message">
           <ErrorIcon width={30} height={30} />
           <Large secondary role="alert" tabIndex={0}>
           {messages['app.payments.confirmation.dataIntegrityError']}
           </Large>
        </div>
        <div>
          <Large secondary role="alert" tabIndex={0}>{messages["app.payments.dataIntegrity.errorMessage"]}</Large>
       </div>
     </div>}
     
     <div className="modal-footer">
       <div style={StyleSheet.flatten(styles.paymentBtnTerminate)}>
     {status==='terminate'?
     <div className="payment-btn">
     <Button
       fullWidth
       onPress={onDone} >
       {messages['app.forgotPassword.button.ok']}
     </Button>
     </div>
     :
     <div style={StyleSheet.flatten(styles.paymentBtnBlock)}>
     <div className="payment-btn" style={StyleSheet.flatten(styles.paymentNewRMrgn)}>
     <Button
       tertiary
       fullWidth
       onPress={onNewPayment} >
       {messages['app.payments.new.payment']}
     </Button>
   </div>
     <div className="payment-btn">
     <Button
      className="btnPaymentDone"
       fullWidth
       onPress={onDone} >
       {messages['app.payments.payment.done']}
     </Button>
   </div>  
   </div>     
   }
    </div>
    </div>
      </div>
    }
  />
)